import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { ResidentService } from '../resident.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ExcelService } from 'src/app/village-staff/excel.service';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-waiver-summary',
  templateUrl: './waiver-summary.component.html',
  styleUrls: ['./waiver-summary.component.scss']
})
export class WaiverSummaryComponent implements OnInit {
  public message: any;
  public remainingCount: any;
  public currentYear: any;
  public vehicleData: any;
  public selectedAll: any;
  private allItems: {} = {};
  public waiver = [];
  private plateNo: any;
  public userSelectedYear: any;
  displayedColumns = ['plateNo', 'createdAt', 'streetNumber', 'street'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private activeRouter: ActivatedRoute,
    private router: Router,
    private residentService: ResidentService,
    private excelService: ExcelService,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    const vehicleData = JSON.parse(localStorage.getItem('registerVehicle'));
    this.message = vehicleData.message;
    this.plateNo = vehicleData.plateNo;
    this.userSelectedYear = vehicleData.userSelectedYear;
    const startDate = vehicleData.startDate;
    //  this.message = this.activeRouter.snapshot.params.message;
    //   this.plateNo = this.activeRouter.snapshot.params.plateNo;
    //   this.userSelectedYear = this.activeRouter.snapshot.params.userSelectedYear;
    //   const startDate = this.activeRouter.snapshot.params.startDate;
    this.residentService.get(this.plateNo, this.userSelectedYear, new Date(startDate)).subscribe((res) => {
      this.remainingCount = res.count ? res.count : 0;
      this.vehicleData = res.vehicle.waiver_vehicle[0].vehicle_details;
      this.vehicleData.forEach(element => {
        element['plateNo'] = res.vehicle.states.state + '-' + res.vehicle.plateNo;
        element['state'] = res.vehicle.states.state;
      });

      //  this.vehicleData.map((data: any) => {
      //    let enf = {
      //      plateNo: data.plateNo,
      //      state: data.states.state,
      //      dateIssued: data.createdAt,
      //      streetNo: data.street_numbers.streetNo,
      //      street: data.streets.street
      //    }
      //    this.waiver.push(enf)
      //  })

      this.dataSource = new MatTableDataSource(this.vehicleData);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      // });
      var d = new Date();
      this.currentYear = d.getFullYear();

    })
  }

  goBack(message) {
    //   let data = {};
    //   const currentWaiverId = localStorage.getItem("waiverId");
    //   data['plateNo'] = this.plateNo;
    //   data['remainingCount'] =  this.remainingCount;
    //   data['userSelectedYear'] = this.userSelectedYear;
    //   data['currentWaiverId'] = currentWaiverId;
    //   data['parkingId'] = this.activeRouter.snapshot.params.parkingId;
    //   // const currentWaiver = this.residentService.getCurrentWaiver();

    //   console.log('.............',currentWaiverId);
    // if(message == 'WAIVER REQUEST APROVED'){
    //   this.residentService.sendApprovedMail(data).subscribe((res)=>{
    //   });
    //   this.snackBar.open('Message :' + 'Mail will be triggered to your mail with approved details.', '', {
    //     duration: 3000,
    //     horizontalPosition: 'right',
    //     panelClass: 'success-snackbar'
    //   });
    // }else{
    //     this.residentService.sendNotApprovedMail(data).subscribe((res)=>{

    //       });
    //       this.snackBar.open('Message :' + 'Mail will be triggered to your mail with not approved details.', '', {
    //         duration: 3000,
    //         horizontalPosition: 'right',
    //         panelClass: 'warning-snackbar'
    //     });

    //   }
    this.router.navigate(['villageofvolo.com/parking'])
  }



  // onSelectAll(event: any, vehicles?: any){
  //   vehicles.filteredData.forEach((vehicle, i) => {
  //     vehicles.filteredData[i].isChecked = event.checked ? 1 : 0;
  //     this.allItems[vehicles.filteredData[i].id] = event.checked ? 1 : 0;
  //     });

  // }
  // checkCheckbox(vehicle: any | any, event: any,){
  //   vehicle.isChecked = event.checked ? 1 : 0;
  // }

  exportAsXLSX() {
    this.excelService.exportAsExcelFile(this.waiver, 'sample');
  }


  // downloadUploadedCsv() {
  //   let csv = ''
  //   if (this.vehicleData) {
  //     for (let row = 0; row < this.vehicleData.length; row++) {
  //       let keysAmount = Object.keys(this.vehicleData[row]).length;
  //       let keysCounter = 0;
  //       if (row === 0) {
  //         for (let key in this.vehicleData[row]) {
  //           csv += key + (keysCounter + 1 < keysAmount ? ',' : '\r\n')
  //           keysCounter++;
  //         }
  //       }
  //       for (let key in this.vehicleData[row]) {
  //         csv += this.vehicleData[row][key] + (keysCounter + 1 < keysAmount ? ',' : '\r\n')
  //         keysCounter++;
  //       }
  //       keysCounter = 0;
  //     }
  //     console.log(csv)
  //     var hiddenElement = document.createElement('a');
  //     hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
  //     hiddenElement.target = '_blank';
  //     hiddenElement.download = 'uploaded.csv';
  //     hiddenElement.click();
  //   }
  // };

}
